import * as React from "react";
import { forwardRef } from "react";
const SvgStar = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.0056 16.6594L7.06109 19.2222L8.00561 13.7941L4 9.95033L9.52774 9.16057L12 4.22217L14.4723 9.16057L20 9.95033L15.9944 13.7941L16.9389 19.2222L12.0056 16.6594Z", stroke: "#2B2B35", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
